import type React from 'react';

import { useLinkActions } from '../../../../hooks/inboxes/useLinkActions';
import LinkDataModal from './LinkDataModal';

export const CreateLinkModal: React.FC = () => {
  const { createLink } = useLinkActions();

  return <LinkDataModal onSubmit={createLink} isAllowedToEditShortLink />;
};

export default CreateLinkModal;
